var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8189 6.14561C21.1363 6.44807 20.4039 6.65319 19.6344 6.74477C20.4201 6.27425 21.0216 5.52795 21.3066 4.6414C20.5696 5.07713 19.756 5.39352 18.8892 5.56504C18.195 4.82452 17.2077 4.36328 16.1125 4.36328C14.0115 4.36328 12.308 6.06683 12.308 8.16671C12.308 8.46452 12.3416 8.7554 12.4065 9.03355C9.24507 8.87477 6.44177 7.36013 4.56556 5.05858C4.23759 5.61949 4.05101 6.27307 4.05101 6.97074C4.05101 8.29071 4.72316 9.45537 5.74298 10.1368C5.1195 10.1159 4.5331 9.9444 4.01974 9.65931V9.70683C4.01974 11.5494 5.33159 13.0873 7.07104 13.4373C6.75235 13.523 6.41629 13.5705 6.06862 13.5705C5.82295 13.5705 5.58538 13.5462 5.35244 13.4998C5.83683 15.0122 7.24141 16.1119 8.90556 16.1421C7.60413 17.1619 5.96316 17.768 4.18083 17.768C3.87374 17.768 3.57126 17.7494 3.27344 17.7158C4.95729 18.7971 6.95635 19.4275 9.10489 19.4275C16.1033 19.4275 19.9288 13.6308 19.9288 8.60361L19.916 8.1111C20.6635 7.57798 21.3101 6.90816 21.8189 6.14561Z",
    fill: "#F2F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_473_4333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 19,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8189 6.14561C21.1363 6.44807 20.4039 6.65319 19.6344 6.74477C20.4201 6.27425 21.0216 5.52795 21.3066 4.6414C20.5696 5.07713 19.756 5.39352 18.8892 5.56504C18.195 4.82452 17.2077 4.36328 16.1125 4.36328C14.0115 4.36328 12.308 6.06683 12.308 8.16671C12.308 8.46452 12.3416 8.7554 12.4065 9.03355C9.24507 8.87477 6.44177 7.36013 4.56556 5.05858C4.23759 5.61949 4.05101 6.27307 4.05101 6.97074C4.05101 8.29071 4.72316 9.45537 5.74298 10.1368C5.1195 10.1159 4.5331 9.9444 4.01974 9.65931V9.70683C4.01974 11.5494 5.33159 13.0873 7.07104 13.4373C6.75235 13.523 6.41629 13.5705 6.06862 13.5705C5.82295 13.5705 5.58538 13.5462 5.35244 13.4998C5.83683 15.0122 7.24141 16.1119 8.90556 16.1421C7.60413 17.1619 5.96316 17.768 4.18083 17.768C3.87374 17.768 3.57126 17.7494 3.27344 17.7158C4.95729 18.7971 6.95635 19.4275 9.10489 19.4275C16.1033 19.4275 19.9288 13.6308 19.9288 8.60361L19.916 8.1111C20.6635 7.57798 21.3101 6.90816 21.8189 6.14561Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_473_4333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4789e4ed2da466dad4034be38658f7ad.svg";
export { ForwardRef as ReactComponent };